import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import UserContextProvier from "./contexts/UserContext";


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
      <UserContextProvier>
            <App />
      </UserContextProvier>
);
